import { render, staticRenderFns } from "./TabCommodityManage.vue?vue&type=template&id=e64b90c4&"
import script from "./TabCommodityManage.vue?vue&type=script&lang=js&"
export * from "./TabCommodityManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports